module.exports = __webpack_public_path__ + "static/media/mobile.7f26c111.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/landing/mobile.png
// module id = 1256
// module chunks = 0